import React from "react";
import "./AlertModal.scss";
import Drawer from "../Drawer/Drawer";
import Button, { BUTTON_VARIANTS } from "../UI/Button/Button";
import Group from "../UI/Group/Group";

export const AlertModal = ({
        title = "",
        description = "",
        handleClose = () =>{},
        textClose = "Fermer",
        textConfirmed,
        handleConfirmed = () =>{}
    }) => {

    return (
        <Drawer
            small
            open={true}
            closeBtn={false}
            handleClose={() => handleClose()}
        >
            <div className="alert-modal">
                <div className="alert-modal-title">
                    {title}
                </div>
                <div className={"alert-modal-description"}>
                    {description}
                </div>
                <Group right>
                    {textConfirmed?.length ? (
                        <Button
                            variant={BUTTON_VARIANTS.REVERSE}
                            onClick={() => {
                                handleConfirmed();
                                handleClose();
                            }}
                        >{textConfirmed}</Button>
                    ) : null}
                    <Button
                        onClick={() => handleClose()}
                    >{textClose}</Button>
                </Group>
            </div>
        </Drawer>
    );
}

export default AlertModal;